<mat-spinner style="position:fixed;top:50%;left:50%" *ngIf="!load"></mat-spinner>

<div class="lti-reg" *ngIf="load">

  <!-- Left: marketing panel -->
  <aside class="lti-reg-left">
    <div class="lti-reg-left-inner">

      <a routerLink="/" class="lti-reg-logo">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

      </a>

      <div class="lti-reg-hero">
        <h1>Run your event<br/>on schedule.</h1>
        <p>Real-time timer control for stage managers, AV crews, and live production teams.</p>
      </div>

      <div class="lti-reg-plan-card">
        <span class="lti-reg-plan-badge">Free plan includes</span>
        <ul class="lti-reg-plan-list">
          <li><mat-icon>check_circle</mat-icon><span>1 Campaign &amp; 10 Timers</span></li>
          <li><mat-icon>check_circle</mat-icon><span>5 Connected Devices</span></li>
          <li><mat-icon>check_circle</mat-icon><span>Instant Setup &amp; Launch</span></li>
          <li><mat-icon>check_circle</mat-icon><span>Ticket-based Support</span></li>
          <li><mat-icon>check_circle</mat-icon><span>Upgrade anytime</span></li>
        </ul>
      </div>

      <div class="lti-reg-footer">© 2026 LetsTimeIt Inc.</div>

    </div>
  </aside>

  <!-- Right: form panel -->
  <main class="lti-reg-right">

    <!-- ── Step 1: social + email ── -->
    <div class="lti-reg-form-wrap" *ngIf="step1">

      <div class="lti-reg-logo lti-reg-logo-mobile">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">
      </div>

      <h2 class="lti-form-title">Create your account</h2>
      <p class="lti-form-sub">No credit card needed — free forever.</p>

      <div class="lti-social-stack">
        <div class="lti-google-btn-wrap">
          <asl-google-signin-button type='standard' logo_alignment="left" shape="rectangular"
            size='large' text="signup_with" theme="outline" width="356"></asl-google-signin-button>
        </div>
        <a href="javascript:void(0)" (click)="signInWithMicrosoft()" class="lti-social-btn">
          <img src="https://panel.letscalendar.com/assets/images/icon-MS.svg" alt="Microsoft" width="16" />
          Continue with Microsoft
        </a>
      </div>

      <div class="lti-divider"><span>or sign up with email</span></div>

      <form [formGroup]="emailForm" (ngSubmit)="setRegEmail()">
        <div class="lti-form-stack">
          <div class="lti-field-wrap">
            <label class="lti-inp-label">Work email</label>
            <div class="lti-input-box">
              <mat-icon class="lti-input-ico">mail_outline</mat-icon>
              <input class="lti-input" type="email" formControlName="email" [maxlength]="150" placeholder="you@company.com" />
            </div>
            @if (emailfrmCtrl.email.invalid && emailfrmCtrl.email.touched) {
              <span class="lti-err">{{errorMessage.email}}</span>
            }
            <span class="lti-err" *ngIf="error" [innerHtml]="error"></span>
          </div>
          <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
            <mat-spinner *ngIf="processing" [diameter]="20"
              style="--mdc-circular-progress-active-indicator-color:#0f0e0a" class="mx-auto"></mat-spinner>
            <span *ngIf="!processing">Continue with email</span>
          </button>
        </div>
      </form>

      <p class="lti-register-hint">
        Already have an account? <a routerLink="" class="lti-link">Sign in</a>
      </p>
    </div>

    <!-- ── Step 2: profile details ── -->
    <form class="lti-reg-form-wrap lti-reg-form-step2" [formGroup]="signupForm" (ngSubmit)="onSubmit()" *ngIf="step2">

      <div class="lti-reg-logo lti-reg-logo-mobile">
        <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">
      </div>

      <div class="lti-step2-head">
        <h2 class="lti-form-title">Complete your profile</h2>
        <p class="lti-form-sub">Almost there — just a few details to get you started.</p>
      </div>

      <div class="lti-reg-fields">

        <!-- Name row -->
        <div class="lti-reg-row">
          <div class="lti-field-wrap">
            <label class="lti-inp-label">First name <span class="lti-req">*</span></label>
            <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.fname.invalid && frmCtrl.fname.touched">
              <mat-icon class="lti-input-ico">person_outline</mat-icon>
              <input class="lti-input" type="text" formControlName="fname" [maxlength]="100" placeholder="First name" />
            </div>
            <span class="lti-err" *ngIf="frmCtrl.fname.invalid && frmCtrl.fname.touched">{{errorMessage.fname}}</span>
          </div>
          <div class="lti-field-wrap">
            <label class="lti-inp-label">Last name <span class="lti-req">*</span></label>
            <div class="lti-input-box">
              <mat-icon class="lti-input-ico">person_outline</mat-icon>
              <input class="lti-input" type="text" formControlName="lname" [maxlength]="100" placeholder="Last name" />
            </div>
            <span class="lti-err" *ngIf="frmCtrl.lname.invalid && frmCtrl.lname.touched">{{errorMessage.lname}}</span>
          </div>
        </div>

        <!-- Email (pre-filled, readonly) -->
        <div class="lti-field-wrap">
          <label class="lti-inp-label">Email <span class="lti-req">*</span></label>
          <div class="lti-input-box lti-input-prefilled">
            <mat-icon class="lti-input-ico lti-input-ico-success">check_circle</mat-icon>
            <input class="lti-input" type="email" formControlName="email" [maxlength]="150" readonly />
          </div>
        </div>

        <!-- Company -->
        <div class="lti-field-wrap">
          <label class="lti-inp-label">Company / Organization <span class="lti-req">*</span></label>
          <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.organization.invalid && frmCtrl.organization.touched">
            <mat-icon class="lti-input-ico">business</mat-icon>
            <input class="lti-input" type="text" formControlName="organization" [maxlength]="150" placeholder="Your company or team name" />
          </div>
          <span class="lti-err" *ngIf="frmCtrl.organization.invalid && frmCtrl.organization.touched">{{errorMessage.organization}}</span>
        </div>

        <!-- Divider -->
        <div class="lti-section-sep">
          <span>Security</span>
        </div>

        <!-- Password row -->
        <div class="lti-reg-row">
          <div class="lti-field-wrap">
            <label class="lti-inp-label">Password <span class="lti-req">*</span></label>
            <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.password.invalid && frmCtrl.password.touched">
              <input class="lti-input" [type]="showPassword ? 'text' : 'password'" formControlName="password" [maxlength]="100" [minlength]="8" placeholder="Min. 8 characters" />
              <button type="button" class="lti-eye-btn" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide' : 'Show'">
                <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </div>
            <span class="lti-err" *ngIf="frmCtrl.password.invalid && frmCtrl.password.touched">{{errorMessage.password}}</span>
          </div>
          <div class="lti-field-wrap">
            <label class="lti-inp-label">Confirm password <span class="lti-req">*</span></label>
            <div class="lti-input-box" [class.lti-input-invalid]="frmCtrl.password_confirmation.invalid && frmCtrl.password_confirmation.dirty && frmCtrl.password_confirmation.touched">
              <input class="lti-input" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="password_confirmation" [maxlength]="100" [minlength]="8" placeholder="Repeat password" />
              <button type="button" class="lti-eye-btn" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="showConfirmPassword ? 'Hide' : 'Show'">
                <mat-icon>{{showConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </div>
            <span class="lti-err" *ngIf="frmCtrl.password_confirmation.invalid && frmCtrl.password_confirmation.dirty && frmCtrl.password_confirmation.touched">{{errorMessage.password_confirmation}}</span>
          </div>
        </div>

        <div class="lti-err-block" *ngIf="error" [innerHtml]="error"></div>

        <button class="lti-submit-btn" type="submit" [disabled]="!submitable">
          <mat-spinner *ngIf="processing" [diameter]="20"
            style="--mdc-circular-progress-active-indicator-color:#0f0e0a" class="mx-auto"></mat-spinner>
          <span *ngIf="!processing">Create account</span>
        </button>

        <p class="lti-reg-terms">
          By signing up you agree to our
          <a href="https://www.letstimeit.com/terms-of-service/" target="_blank" class="lti-link">Terms of Service</a>
          and <a href="https://www.letstimeit.com/privacy-policy/" target="_blank" class="lti-link">Privacy Policy</a>.
        </p>

      </div>
      <input type="hidden" name="email3" id="email3" />
    </form>

  </main>
</div>
